import AuthService from '@/services/auth.service';
import { UserManager } from 'oidc-client-ts';

class UserManagerEventsService {
  private isInitialized = false;

  initialize(userManager: UserManager): void {
    if (this.isInitialized) {
      console.warn('UserManager events already initialized');
      return;
    }

    // Handle successful user loading (including after silent renewal)
    userManager.events.addUserLoaded((user) => {
      if (AuthService.hasLogoutIntent()) {
        void userManager.removeUser();
        return;
      }

      AuthService.setTokens({
        access_token: user.access_token,
        expires_at: (user.expires_at || 0) * 1000, // Convert to milliseconds
      });
    });

    userManager.events.addSilentRenewError((error) => {
      console.warn('Silent token renewal failed:', error);
      // Only clear tokens if it's a critical error that requires re-authentication
      if (error && typeof error === 'object' && 'error' in error) {
        const errorObj = error as { error: string };
        if (errorObj.error === 'login_required' || errorObj.error === 'interaction_required') {
          AuthService.clearTokens();
        }
      }
    });

    userManager.events.addUserUnloaded(() => {
      AuthService.clearTokens();
    });

    this.isInitialized = true;
  }
}

export default new UserManagerEventsService();
